import type {Result, UseCase} from 'framework';
import type {OnboardingStatus} from '../../domain/onboarding-status.value-object';
import type {OnboardingStatusRepository} from '../ports/onboarding-status.repository';

export class CheckOnboardingStatus implements UseCase<[], OnboardingStatus> {
  constructor(private readonly onboardingStatusRepository: OnboardingStatusRepository) {}

  execute(): Promise<Result<OnboardingStatus>> {
    return this.onboardingStatusRepository.getStatus();
  }
}
